import PropTypes from "prop-types"

import icon from "images/icons/icon-delay.svg"

export default function DelayIcon({ title }) {
  return (
    <span
      className="svg-icon"
      title={title}
      dangerouslySetInnerHTML={{ __html: icon }}
    />
  )
}

DelayIcon.propTypes = {
  title: PropTypes.string,
}
